var path = '/var/www/mmscny-website/src/app/common/app-nav/app-nav-footer-contact.html';
var html = "<div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 footer-contact\" ng-if=$ctrl.getThereProgramCallCenter.slug> <div class=\"container body-container\"> <p class=text-capitalize>want transport assistance? contact GetThere</p> <div class=white-button> <button type=button ui-sref=DynamicMenus({url:$ctrl.getThereProgramCallCenter.slug})><div class=\"btn-white text-uppercase\"><a>click here</a></div></button> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app-nav/app-nav-footer-contact.html
// module id = 638
// module chunks = 0